(function(){
  var root=document.getElementById('mbd');
  if(!root) return;

  var cfg={};
  try{ cfg=JSON.parse(root.getAttribute('data-cfg')||'{}'); }catch(e){ cfg={}; }
  var THRESHOLD = cfg.threshold || 0;
  var COMPARE = cfg.compare || {};
  var SHIP_ID  = cfg.shipId ? String(cfg.shipId) : '';

  var elCount=root.querySelector('[data-mbd-count]');
  var elShip=root.querySelector('[data-mbd-ship]');
  var elItems=root.querySelector('[data-mbd-items]');
  var elTotal=root.querySelector('[data-mbd-total]');
  var elPrio=root.querySelector('[data-mbd-prio]');
  var elPrioSw=root.querySelector('[data-mbd-prio-switch]');

  function money(c){
    var n;
    try{ n=new Intl.NumberFormat('es-MX',{minimumFractionDigits:2,maximumFractionDigits:2}).format(c/100); }
    catch(e){ n=(c/100).toFixed(2); }
    return '$ '+n+' MXN';
  }
  function esc(s){ return String(s==null?'':s).replace(/[&<>"']/g,function(m){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m]; }); }
  function busy(on){ root.setAttribute('data-busy', on?'1':'0'); }
  function esServicio(id){ return String(id)===SHIP_ID; }

  function open(){
    root.hidden=false;
    root.setAttribute('data-open','1');
    document.documentElement.style.overflow='hidden';
  }
  function close(){
    root.setAttribute('data-open','0');
    document.documentElement.style.overflow='';
    setTimeout(function(){ if(root.getAttribute('data-open')!=='1') root.hidden=true; },300);
  }

  var TRASH='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18M8 6V4h8v2m-9 0 1 14h8l1-14"/></svg>';

  function linea(cart,id){
    var n=-1;
    cart.items.forEach(function(it,i){ if(String(it.variant_id)===String(id)) n=i+1; });
    return n;
  }
  // el envio prioritario no cuenta para el envio gratis
  function baseTotal(cart){
    var t=cart.total_price;
    cart.items.forEach(function(it){ if(esServicio(it.variant_id)) t-=it.final_line_price; });
    return t;
  }

  function renderShip(total){
    if(!elShip) return;
    if(!THRESHOLD){ elShip.innerHTML=''; return; }
    var falta=THRESHOLD-total;
    if(falta>0){
      var pct=Math.max(2,Math.min(100,Math.round(total*100/THRESHOLD)));
      elShip.innerHTML='<p>Te faltan <b>'+money(falta)+'</b> para el envío gratuito</p>'+
        '<div class="mbd__bar"><div class="mbd__fill" style="width:'+pct+'%"></div></div>';
    }else{
      elShip.innerHTML='<p class="ok">✓ Ya tienes envío gratuito</p>'+
        '<div class="mbd__bar"><div class="mbd__fill ok" style="width:100%"></div></div>';
    }
  }

  function renderItems(cart){
    var visibles=cart.items.filter(function(it){ return !esServicio(it.variant_id); });
    if(!visibles.length){
      elItems.innerHTML='<div class="mbd__empty">Tu carrito está vacío.</div>';
      return;
    }
    var html='';
    cart.items.forEach(function(it,i){
      if(esServicio(it.variant_id)) return;
      var line=i+1;
      var cmp=COMPARE[String(it.variant_id)]||0;
      var cmpTotal=cmp*it.quantity;
      var ahorro=cmpTotal-it.final_line_price;
      var img=it.image? it.image.replace(/(\.[a-z]+)(\?|$)/i,'_200x200$1$2') : '';
      html+='<div class="mbd__it">'+
        (img?'<img src="'+esc(img)+'" alt="'+esc(it.product_title)+'" loading="lazy">':'<img alt="">')+
        '<div class="mbd__ic">'+
          '<div class="mbd__top">'+
            '<div class="mbd__nm">'+esc(it.product_title)+
              (it.variant_title && it.variant_title!=='Default Title' ? '<p class="mbd__var">'+esc(it.variant_title)+'</p>' : '')+
            '</div>'+
            '<button class="mbd__rm" type="button" data-line="'+line+'" data-qty="0" aria-label="Quitar">'+TRASH+'</button>'+
          '</div>'+
          '<div class="mbd__row">'+
            '<span class="mbd__qty">'+
              '<button type="button" data-line="'+line+'" data-qty="'+(it.quantity-1)+'" aria-label="Quitar uno">−</button>'+
              '<span>'+it.quantity+'</span>'+
              '<button type="button" data-line="'+line+'" data-qty="'+(it.quantity+1)+'" aria-label="Añadir uno">+</button>'+
            '</span>'+
            '<span class="mbd__pr">'+
              (ahorro>0?'<span class="mbd__was">'+money(cmpTotal)+'</span>':'')+
              '<span class="mbd__now">'+money(it.final_line_price)+'</span>'+
              (ahorro>0?'<span class="mbd__sv">Ahorras '+money(ahorro)+'</span>':'')+
            '</span>'+
          '</div>'+
        '</div>'+
      '</div>';
    });
    elItems.innerHTML=html;
  }

  function renderPrio(cart){
    if(!elPrio || !SHIP_ID) return;
    var reales=cart.items.filter(function(it){ return !esServicio(it.variant_id); });
    elPrio.hidden = reales.length===0;
    if(elPrioSw){
      var puesto = linea(cart, SHIP_ID) > 0;
      elPrioSw.setAttribute('data-on', puesto?'1':'0');
      elPrioSw.setAttribute('aria-checked', puesto?'true':'false');
    }
  }

  function pintar(cart){
    var reales=cart.items.filter(function(it){ return !esServicio(it.variant_id); });
    var cuenta=reales.reduce(function(a,b){ return a+b.quantity; },0);
    if(elCount) elCount.textContent=cuenta;
    if(elTotal) elTotal.textContent=money(cart.total_price);
    renderShip(baseTotal(cart));
    renderItems(cart);
    renderPrio(cart);
    document.querySelectorAll('[data-mbd-badge]').forEach(function(b){ b.textContent=cuenta; });
  }

  function refresh(){
    return fetch('/cart.js',{headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(c){ pintar(c); return c; });
  }

  function change(line,qty){
    busy(true);
    return fetch('/cart/change.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({line:line,quantity:qty})
    }).then(function(r){ return r.json(); })
      .then(function(c){ busy(false); pintar(c); })
      .catch(function(){ busy(false); refresh(); });
  }

  function add(id,qty){
    busy(true);
    return fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items:[{id:Number(id),quantity:qty||1}]})
    }).then(function(r){ return r.json(); })
      .then(function(){ return refresh(); })
      .then(function(){ busy(false); open(); })
      .catch(function(){ busy(false); });
  }

  function togglePrio(){
    busy(true);
    fetch('/cart.js',{headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var n=linea(cart,SHIP_ID);
        if(n>0) return change(n,0);
        return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
          body:JSON.stringify({items:[{id:Number(SHIP_ID),quantity:1}]})})
          .then(function(){ return refresh(); }).then(function(){ busy(false); });
      })
      .catch(function(){ busy(false); refresh(); });
  }

  root.addEventListener('click', function(e){
    var c=e.target.closest('[data-mbd-close]');
    if(c){ e.preventDefault(); close(); return; }
    var sw=e.target.closest('[data-mbd-prio-switch]');
    if(sw){ e.preventDefault(); if(!sw.disabled) togglePrio(); return; }
    var q=e.target.closest('.mbd__qty button, .mbd__rm');
    if(q){ e.preventDefault(); change(Number(q.getAttribute('data-line')), Number(q.getAttribute('data-qty'))); return; }
    var co=e.target.closest('[data-mbd-checkout]');
    if(co){ e.preventDefault(); window.location.href='/checkout'; return; }
  });

  document.addEventListener('keydown', function(e){ if(e.key==='Escape' && root.getAttribute('data-open')==='1') close(); });

  document.addEventListener('submit', function(e){
    var f=e.target;
    if(!f || !f.action || f.action.indexOf('/cart/add')===-1) return;
    var idInput=f.querySelector('[name="id"]');
    if(!idInput) return;
    var qtyInput=f.querySelector('[name="quantity"]');
    e.preventDefault();
    e.stopPropagation();
    add(idInput.value, qtyInput? Number(qtyInput.value)||1 : 1);
  }, true);

  document.addEventListener('click', function(e){
    var a=e.target.closest('a[href$="/cart"], a[href*="/cart?"], [data-mbd-open]');
    if(!a) return;
    e.preventDefault();
    e.stopPropagation();
    refresh().then(open);
  }, true);

  refresh();
  window.pupexCart={open:open,close:close,refresh:refresh,add:add};
})();
